export const otherLibs = [
  {
    name: "redux",
    experience: "5 years",
    rate: 5,
  },
  {
    name: "semantic-UI",
    experience: "2 years",
    rate: 5,
  },
  {
    name: "shadcn/ui",
    experience: "3 years",
    rate: 5,
  },
  {
    name: "material-UI",
    experience: "3 years",
    rate: 4,
  },
];
